/** Default fallback for user settings in CSP */

export default {
  audio_settings: {
    alerts: {
      volume: 0.7,
    },
  },
};
